var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57126 8.91456C3.3923 8.70426 3.07674 8.67885 2.86644 8.85781C2.65614 9.03677 2.63073 9.35233 2.80969 9.56264L3.57126 8.91456ZM11.5 6C11.5 8.48528 9.48528 10.5 7 10.5V11.5C10.0376 11.5 12.5 9.03757 12.5 6H11.5ZM2.5 6C2.5 3.51472 4.51472 1.5 7 1.5V0.5C3.96243 0.5 1.5 2.96243 1.5 6H2.5ZM7 1.5C9.48528 1.5 11.5 3.51472 11.5 6H12.5C12.5 2.96243 10.0376 0.5 7 0.5V1.5ZM7 10.5C5.62669 10.5 4.39744 9.88544 3.57126 8.91456L2.80969 9.56264C3.81775 10.7473 5.32123 11.5 7 11.5V10.5Z",
    fill: "#7471FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.38086V6.4761L8.42857 7.66657",
    stroke: "#7471FF",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7L0.267949 4L3.73205 4L2 7Z",
    fill: "#7471FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3280e5fc6d29d65f4cfc6bc798025381.svg";
export { ForwardRef as ReactComponent };